<template>
  <bita-modal
    :id="id"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoadingModal"
    @close="reset()"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.title"
            />
            <bita-input
              type="text"
              name="slug"
              label="آدرس"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.slug"
            />
            <bita-textarea
              name="description"
              ref="descriptionTextarea"
              label="توضیح مختصر"
              rules=""
              validation-container-class="col-lg-12"
              input-class="form-control"
              v-model="formData.description"
            />
            <bita-texteditor
              name="content"
              ref="contentTextarea"
              label="محتوای صفحه"
              rules=""
              validation-container-class="col-lg-12"
              input-class="form-control"
              v-model="formData.content"
            />
          </div>
          <bita-formgroup title="سئو" class="row" style="margin-top:30px">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="formData.title_seo"
            />
            <bita-textarea
              type="text"
              name="title"
              label="توضیحات"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="formData.description_seo"
            />
            <!-- <bita-input
              type="text"
              name="canonical"
              label="کنونیکال"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="formData.canonical"
            /> -->
            <bita-typeahead
              type="text"
              name="name"
              label="کلمه های کلیدی"
              :validation-container-class="largeColWidth"
              input-class="form-control"
              :data-source="matches"
              v-model="tags"
              @on-search="(e) => loadDataSource(e)"
            />
          </bita-formgroup>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="handleCreate"
      />
      <bita-bootbutton
        v-if="formData.id"
        type="primary"
        title="به روزرسانی"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="handleUpdate"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
      />
    </div>
  </bita-modal>
</template>
<script>
import { tagApi } from "@/api/apiManagement";
export default {
  props: {
    isLoading: Boolean,
    title: String,
    id: String,
    propsData: {},
  },
  data() {
    return {
      colWidth: "col-lg-4",
      largeColWidth: "col-lg-12",
      formData: {},
      isLoadingModal: false,
      tags: [],
      matches: [],
    };
  },
  watch: {
    propsData: function(_val) {
      this.formData = {
        ..._val,
        title_seo: _val?.seo?.title,
        description_seo: _val?.seo?.description,
        canonical: _val?.seo?.canonical,
      };
      this.tags = _val.tag_names ?? [];
      this.setInitialValue(_val.content);
    },
    isLoading: function(_val) {
      this.isLoadingModal = _val;
    },
  },
  methods: {
    setInitialValue(_data) {
      // this.form = _data;
      this.$refs.contentTextarea.setInitialValue(_data ? _data : "");
    },
    loadDataSource(tag) {
      tagApi.findTags({ tag: tag }).then((res) => {
        this.matches = collect(res.data.entity)
          .pluck("name.fa")
          .toArray();
      });
    },
    handleCreate() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", {
            ...this.formData,
            tags: this.tags.join(","),
          });
        }
      });
    },
    handleUpdate() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", {
            ...this.formData,
            tags: this.tags.join(","),
          });
        }
      });
    },
    setErrors(err) {
      this.$refs.form.setErrors(err);
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>
